<sn-drawer>
  <ng-container *ngIf="data$ | async as data; else loader">
    <sn-drawer-header [title]="data.camera.name">
      <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
      <ng-container *ngIf="insecureUrl"> This stream url is insecure. </ng-container>
      <sn-drawer-header-actions
        [actions]="data.actions"
        [context]="data.camera"
      ></sn-drawer-header-actions>
    </sn-drawer-header>

    <sn-audit-camera-stream-view
      *ngIf="data.camera?.isLive"
      [camera]="data.camera"
    ></sn-audit-camera-stream-view>

    <sn-camera-details
      snDrawerContent
      [camera]="data.camera"
      (tagsChanged)="onTagsChanged($event, data)"
    ></sn-camera-details>
  </ng-container>
</sn-drawer>

<ng-template #loader>
  <mat-spinner class="align-self-center" [diameter]="48" [strokeWidth]="4"></mat-spinner>
</ng-template>
